export default {
  path: '/:type/createwecode',
  auth: true,
  preload: false,
  key: 'createwecode',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import( /* webpackChunkName: "createwecode" */'./index')
};
